export default __webpack_public_path__ + "static/media/aramex.79ebe6b3.svg";